import M_TOOLKIT from '../../../../main/components/toolkit/index.js'
import { G_APP_LOG_TYPE_MAP } from '../../../../config/index.js'

// 基础上报字段模板
const BASIC_TEMPLE = () => {
    return {
        record_type: G_APP_LOG_TYPE_MAP.behavior, // 页面行为
        time: M_TOOLKIT.getTime(), // 时间戳
        page_name: '', // 页面名称，一般不需要传递由app取统跳的值或取页面title
        event_pos: '', // 点击流
        event_pos_name: '', // 点击流的名字
        event_type: '', // 行为类型 1：曝光；2：点击；3：截屏；
        isc: '', // isc
        page_url: '', // 页面路径 如果有传递则依据传递值为准，无则app自行获取
        refer_url: '', // referer_url路径 如果有传递则依据传递值为准，无则app自行获取
        extend_info: {}, // 扩展信息
        standard_extend_info: {}, // 扩展信息(新字段)
        event_case_code: '' // 埋点code(新字段)
    }
}

// 单条数据上报结构
const handleSingleData = (params) => {
    // app_log_type默认为行为数据
    let { public_params, content_params, business_params, event_params, location_params, origin_params} = params
    // 经过其他层次上报后，会多一层origin_params，数据结构需要进行降维处理
    if (!event_params && origin_params.event_params) {
        event_params = origin_params.event_params
        origin_params = origin_params.origin_params || origin_params
    }

    const app_log_type = G_APP_LOG_TYPE_MAP.behavior
    let data_tpl = BASIC_TEMPLE()

    // 对business_params进行处理：
    // APP内：由原生自动注入，与以下逻辑一致
    // APP外：当有缓存业务公参时，业务无法通过pageReport api主动上报业务公参，会被缓存覆盖
    // APP外：当无缓存业务公参时，业务可以通过pageReport api主动上报业务公参
    if (M_TOOLKIT.isEmptyObject(business_params) && origin_params.business_params) {
        business_params = origin_params.business_params
    }
    
    return {
        action: 'uploadWebDataSingleReport',
        content: {
            public: public_params,
            data: {
                record_list: [{
                    ...data_tpl,
                    ...origin_params, // 原始参数
                    ...content_params, // 公共内容
                    ...location_params, // 位置信息
                    business_params, // 业务公参
                    event_params // 事件公参
                }],
                app_log_type
            }
        }
    }
}

export default {
    handleSingleData
}